<template>
    <div class="www pb-2 select-none">
        <div class="pt-5">
            <SwitchButton
                v-model="activeComponents.showBlocks"
                :state="activeComponents.showBlocks ? 'success' : 'neutral'"
                :label="t('templateShowBlocks')"
                :label-on="t('templateShowBlocksShow')"
                :label-off="t('templateShowBlocksHide')"
            />
        </div>
    </div>
</template>

<script setup>
import { t } from '../composables/i18n';
import SwitchButton from '../ui/SwitchButton.vue';

defineExpose({
    name: 'BlockShowWidget',
});

const props = defineProps({
    activeComponents: {
        type: Object,
        required: true,
    },
    stateRepository: {
        type: Object,
        required: true,
    },
});

const activeComponents = props.activeComponents;
//const stateRepository = props.stateRepository;
</script>
